export function formatDate(isoString) {
    // 解析 ISO 8601 时间字符串为 Date 对象
    const date = new Date(isoString);
  
    // 检查是否成功解析日期
    if (isNaN(date.getTime())) {
      throw new Error('Invalid date string');
    }
  
    // 获取年、月、日
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1 并填充前导零
    const day = String(date.getDate()).padStart(2, '0'); // 获取日期并填充前导零
  
    // 返回格式化的日期字符串
    return `${year}-${month}-${day}`;
  }